import React from "react";
import { useState } from "react";
import { Flex, Group, Stepper, Box, Text, Title, Button } from "@mantine/core";

import { CustomDrawer, CustomSelect } from "@components/custom";

export const DrawerStylesheet = () => {
  const [opened, setOpened] = useState(false);
  return (
    <>
      <Group mt="xl" mb="xl" wrap="wrap">
        <Button onClick={() => setOpened(true)}>Open Drawer</Button>
      </Group>
      <CustomDrawer
        opened={opened}
        onClose={() => setOpened(false)}
        padding="xl"
        size="xl"
        position="right"
      >
        <CustomDrawer.Header>
          <Title order={2}>Drawer Title</Title>
          <Flex
            gap="md"
            justify="space-between"
            align="bottom"
            mt="xl"
            wrap="wrap"
          >
            <CustomSelect
              variant="dark"
              placeholder="Choose an option"
              data={[
                { value: "option1", label: "Option 1" },
                { value: "option2", label: "Option 2" },
                { value: "option3", label: "Option 3" },
              ]}
              mb="md"
            ></CustomSelect>
            <Button size="sm" onClick={() => setOpened(false)}>
              New Something
            </Button>
          </Flex>
          <Box mt="xl">
            <Stepper active={1} size="sm">
              <Stepper.Step></Stepper.Step>
              <Stepper.Step></Stepper.Step>
              <Stepper.Step></Stepper.Step>
            </Stepper>
          </Box>
        </CustomDrawer.Header>
        <CustomDrawer.Body>
          <Text mb="md">Content goes here</Text>
        </CustomDrawer.Body>
        <CustomDrawer.Footer>
          <Flex gap="md" wrap="wrap">
            <Button size="sm" onClick={() => setOpened(false)}>
              Discard Changes
            </Button>
            <Button size="sm" onClick={() => setOpened(false)}>
              Save Changes
            </Button>
          </Flex>
        </CustomDrawer.Footer>
      </CustomDrawer>
    </>
  );
};
